export const blogData = [
    {
        id: 1,
        title: 'What happens when you type google.com in your browser and press Enter',
        description: 'Discover the complex process behind a simple web search, from DNS lookup to secure data transfer, in this concise blog.',
        date: 'Dec 16, 2023',
        image: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*OTtf-c6j9-Ap6-Bu4RYTvg.png',
        url: 'https://medium.com/@shadrackipruto/what-happens-when-you-type-google-com-in-your-browser-and-press-enter-d46b5f6d2b24'
    },
    {
        id: 2,
        title: 'Incident Reporting',
        description: 'Outage Incident Report: Unforeseen downtime in tallying services',
        date: 'Jan 20, 2024',
        image: 'https://miro.medium.com/v2/resize:fit:786/format:webp/1*vTZApFdAGPNCqq0q289Ndg.jpeg',
        url: 'https://medium.com/@shadrackipruto/outage-incident-report-unforeseen-downtime-in-tallying-services-a7b7cea9231b'
    },
    // {
    //     id: 3,
    //     title: 'Reliance Digital Clone (Part II)',
    //     description: 'The experience of the third project, with a focus on leadership skills',
    //     date: 'Feb 27, 2022',
    //     image: 'https://miro.medium.com/max/875/1*qRNfRbuHCDC1ct0chLZoWA.png',
    //     url: 'https://medium.com/@sreerag.rajan5/reliance-digital-clone-part-ii-57797eaf1ddf'
    // },
    
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/